import {
  ButtonType,
  ButtonState,
  StylesByType,
} from './Button.types';
import { YodaColors } from 'yoda-ui/yodaTheme';

const ButtonStyles: StylesByType = {
  [ButtonState.normal]: {
    [ButtonType.primary]: {
      backgroundColor: `${YodaColors.blue7}`,
      color: `${YodaColors.white}`,
      border: `2px solid ${YodaColors.white}`,
    },
    [ButtonType.secondary]: {
      backgroundColor: `${YodaColors.white}`,
      color: `${YodaColors.blue7}`,
      border: `2px solid ${YodaColors.blue7}`,
    },
    [ButtonType.neutral]: {
      backgroundColor: `${YodaColors.white}`,
      color: `${YodaColors.blue7}`,
      border: `2px solid ${YodaColors.blue7}`,
    },
    [ButtonType.outlined]: {
      backgroundColor: 'transparent',
      color: `${YodaColors.blue7}`,
      border: `1px solid ${YodaColors.blue7}`,
    },
    [ButtonType.home]: {
      backgroundColor: `${YodaColors.blue7}`,
      color: `${YodaColors.white}`,
      border: `2px solid ${YodaColors.blue7}`,
    },
  },
  [ButtonState.hover]: {
    [ButtonType.primary]: {
      backgroundColor: `${YodaColors.blue8}`,
      color: `${YodaColors.white}`,
      border: `2px solid ${YodaColors.white}`,
    },
    [ButtonType.secondary]: {
      backgroundColor: `${YodaColors.blue2}`,
      color: `${YodaColors.blue7}`,
      border: `2px solid ${YodaColors.blue7}`,
    },
    [ButtonType.neutral]: {
      backgroundColor: `${YodaColors.blue2}`,
      color: `${YodaColors.blue7}`,
      border: `2px solid ${YodaColors.blue7}`,
    },
    [ButtonType.outlined]: {
      backgroundColor: `${YodaColors.blue7}`,
      color: `${YodaColors.white}`,
      border: `1px solid ${YodaColors.blue7}`,
    },
    [ButtonType.home]: {
      backgroundColor: `${YodaColors.blue8}`,
      color: `${YodaColors.white}`,
      border: `2px solid ${YodaColors.blue8}`,
    },
  },
  [ButtonState.disabled]: {
    [ButtonType.primary]: {
      backgroundColor: `${YodaColors.gray1}`,
      color: `${YodaColors.gray3}`,
      border: `2px solid ${YodaColors.white}`,
    },
    [ButtonType.secondary]: {
      backgroundColor: `${YodaColors.white}`,
      color: `${YodaColors.gray3}`,
      border: `2px solid ${YodaColors.white}`,
    },
    [ButtonType.neutral]: {
      backgroundColor: `${YodaColors.gray1}`,
      color: `${YodaColors.gray3}`,
      border: `2px solid ${YodaColors.white}`,
    },
    [ButtonType.outlined]: {
      backgroundColor: 'transparent',
      color: `${YodaColors.gray3}`,
      border: `1px solid ${YodaColors.gray3}`,
    },
  },
  [ButtonState.focus]: {
    [ButtonType.primary]: {
      backgroundColor: `${YodaColors.blue7}`,
      color: `${YodaColors.white}`,
      border: `2px dashed ${YodaColors.white}`,
    },
    [ButtonType.secondary]: {
      backgroundColor: `${YodaColors.gray1}`,
      color: `${YodaColors.blue7}`,
      border: `2px dashed ${YodaColors.blue7}`,
    },
    [ButtonType.neutral]: {
      backgroundColor: `${YodaColors.white}`,
      color: `${YodaColors.blue7}`,
      border: `2px dashed ${YodaColors.blue7}`,
    },
    [ButtonType.outlined]: {
      backgroundColor: 'transparent',
      color: `${YodaColors.blue7}`,
      border: `1px solid ${YodaColors.blue7}`,
    },
  },
};

export default ButtonStyles;
